/* PBK 汎用パララックス: [data-pbk-parallax] 枠内の img をスクロール連動で縦に translate。
   方向は常に「背景 = 手前の要素よりゆっくり」（遠景ほど遅い＝奥行き）。詳細は apply() 内コメント。
   枠(.pbk-fx)は overflow:hidden、img は枠より縦に大きく(top負・height calc(100%+2R))はみ出させておく。
   data-pbk-parallax-origin="top" で「ページ最上部で中央クロップ」に基準を変更（既定は枠が画面中央のとき）。
   reduced-motion / data-static(ハーネス撮影) では中央静止。hover拡大は別要素(.pbk-fx__inner)がCSSで担当。 */
(() => {
  const frames = Array.prototype.slice.call(document.querySelectorAll('[data-pbk-parallax]'));
  if (!frames.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const items = frames
    .map((f) => ({ frame: f, img: f.querySelector('img') }))
    .filter((i) => i.img);
  if (!items.length) return;
  let raf = 0;
  const clear = () => items.forEach((i) => { i.img.style.transform = ''; });
  const apply = () => {
    raf = 0;
    const vh = window.innerHeight;
    items.forEach(({ frame, img }) => {
      let max = (img.offsetHeight - frame.clientHeight) / 2; // 片側はみ出し量
      // data-pbk-parallax-max="60" で振幅だけ抑制（はみ出し量より小さく動かす。静止クロップは不変）
      const cap = parseFloat(frame.dataset.pbkParallaxMax || '');
      if (!Number.isNaN(cap) && cap >= 0) max = Math.min(max, cap);
      if (max <= 0.5) { img.style.transform = ''; return; }
      const box = frame.getBoundingClientRect();
      const p = (box.top + box.height / 2 - vh / 2) / (vh / 2 + box.height / 2);
      // 既定の基準は「枠が画面中央に来たとき中央クロップ」。data-pbk-parallax-origin="top" を付けると
      // 「ページ最上部(scrollY=0)で中央クロップ」に変わる（ファーストビューに写真がある section 向け）
      let base = 0;
      if (frame.dataset.pbkParallaxOrigin === 'top') {
        const docTop = box.top + window.scrollY;
        base = (docTop + box.height / 2 - vh / 2) / (vh / 2 + box.height / 2);
      }
      // 符号は「奥行き」= 背景はスクロールより遅く動く（手前の要素より遅い＝遠くに見える）。
      // 画像の画面上の移動量 = 枠の移動(-1) + 枠内 translate。p は下スクロールで減るので
      // -p*max とすると translate が増え、実効速度が -(1 - k) = 等倍より遅くなる。
      // +p*max（符号逆）だと -(1 + k) で背景が手前より速く動き、奥行きが反転する。
      const y = -Math.max(-1, Math.min(1, p - base)) * max;
      img.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
    });
  };
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
  const isStatic = () =>
    reduce.matches ||
    document.documentElement.hasAttribute('data-static') ||
    document.body.hasAttribute('data-static');
  if (isStatic()) { clear(); return; }
  apply();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
